import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Modals from 'root/modals';
import Constants from 'root/constants';
import View from 'view/base';

export default View.extend({
    confirmation_is_disabled: true,
    confirmation_email_subject: '',
    confirmation_email_html: '',
    confirmation_feedback_type: [],

    events: {
        'click .dropdown-user li'              : 'onSelectAssignee',
        'click .dropdown-day li'               : 'onSelectDueDate',
        'click .feedback-auto-reopen'          : 'onToggleFeedbackAutoReopen',
        'click .confirmation-is-disabled'      : 'onToggleConfirmationEmail',
        'click .autoreply-is-disabled'         : 'onToggleAutoReply',
        'click .edit-content'                  : 'onEditContent',
        'click .account-upgrade'               : 'onUpgradeAccount'
    },

    dom_handlers: {
        onSelectAssignee: function(e) {
            var assignee_type = $(e.currentTarget).parent().data('val');
            var assignee_id   =  parseInt($(e.currentTarget).data('id'), 10);
            var setting_name  = 'default_assignee_id_' + assignee_type;

            this.model.set(setting_name, assignee_id);
            this.renderNewFeedbackAutomation(assignee_type);

            Cache.app.trackOnboarding('default_assignee_set', '1');

            Cache.app.request({
                action: 'project/update',
                data: {
                    project_id: this.model.id,
                    [setting_name] : assignee_id
                },
                success: (response) => {
                    UI.success('Default assignee updated');
                }
            });
        },

        onSelectDueDate: function(e) {
            var type = $(e.currentTarget).parent().data('val');
            var due_days = parseInt($(e.currentTarget).data('id'), 10);
            var setting_name = 'default_due_day_' + type;

            this.model.set(setting_name, due_days);
            this.renderNewFeedbackAutomation(type);

            Cache.app.request({
                action: 'project/update',
                data: {
                    project_id: this.model.id,
                    [setting_name] : due_days
                },
                success: (response) => {
                    UI.success('Default due date updated');
                }
            });
        },

        onToggleFeedbackAutoReopen: function(e) {
            this.model.set('feedback_auto_reopen', !this.model.get('feedback_auto_reopen'));

            if (this.model.get('feedback_auto_reopen')) {
                this.$el.find('.feedback-auto-reopen').addClass('switch-on').removeClass('switch-off');
            } else {
                this.$el.find('.feedback-auto-reopen').addClass('switch-off').removeClass('switch-on');
            }

            Cache.app.request({
                action: 'project/update',
                data: {
                    project_id: this.model.id,
                    feedback_auto_reopen : this.model.get('feedback_auto_reopen')
                },
                success: (response) => {
                    UI.success('Reopen feedback updated');
                }
            });
        },

        onToggleConfirmationEmail: function(e) {
            let is_disabled;
            if ($(e.currentTarget).hasClass('switch-on')) {
                is_disabled = true;
                $(e.currentTarget).removeClass('switch-on').addClass('switch-off');
            } else {
                is_disabled = false;
                $(e.currentTarget).removeClass('switch-off').addClass('switch-on');
            }

            Cache.app.request({
                action: 'feedback\\Confirmation/save',
                data:{
                    id: this.feedback_confirmation.id,
                    is_disabled: is_disabled,
                    email_subject: this.feedback_confirmation.get('email_subject'),
                    email_html: this.feedback_confirmation.get('email_html'),
                    feedback_type: this.feedback_confirmation.get('feedback_type')
                },
                success: (response) => {
                    UI.success('Reporter notification updated');
                    this.feedback_confirmation.set(response);
                },
                complete: () => {
                    this.$el.find('.confirmation-form').find('button:submit').removeClass('loading').prop('disabled', false);
                }
            });
        },

        onToggleAutoReply: function(e) {
            let is_disabled;
            if ($(e.currentTarget).hasClass('switch-on')) {
                is_disabled = true;
                $(e.currentTarget).removeClass('switch-on').addClass('switch-off');
            } else {
                is_disabled = false;
                $(e.currentTarget).removeClass('switch-off').addClass('switch-on');
            }

            Cache.app.request({
                action: 'feedback\\Autoreply/update',
                data:{
                    id: this.feedback_autoreply ? this.feedback_autoreply.id : 0,
                    is_disabled: is_disabled,
                    content: this.feedback_autoreply ? this.feedback_autoreply.get('content') : '',
                    feedback_type: this.feedback_autoreply ? this.feedback_autoreply.get('feedback_type').split(',').map((type) => parseInt(type, 10)) : []
                },
                success: (response) => {
                    UI.success('Auto-reply notification updated');
                    if (!this.feedback_autoreply) {
                        Cache.feedback_autoreply.add(response);
                        this.feedback_autoreply = Cache.feedback_autoreply.findWhere({project_id: this.model.id});
                        return;
                    }
                    this.feedback_autoreply.set(response);
                },
                complete: () => {
                    this.$el.find('.autoreply-form').find('button:submit').removeClass('loading').prop('disabled', false);
                }
            });
        },

        onEditContent: function(e) {
            e.preventDefault();

            var type = $(e.currentTarget).data('type');

            if (type === 'confirm') {
                Modals.editConfirmationEmail(this.feedback_confirmation.get('project_id'));
            } else if (type === 'auto_reply') {
                Modals.editAutoReplyContent(this.feedback_autoreply?.get('project_id'));
            }
        },

        onUpgradeAccount: function() {
            Modals.choosePlan();
        }
    },

    event_handlers: {
        handleAddFeedbackAutoreply: function(model) {
            if (model.get('project_id') !== this.model.id) return;

            this.feedback_autoreply = model;
            this.render();
        },

        handleAddFeedbackConfirmation: function(model) {
            if (model.get('project_id') !== this.model.id) return;

            this.feedback_confirmation = model;
            this.render();
        }
    },

    initialize: function() {
        this.feedback_confirmation = Cache.feedback_confirmation.findWhere({project_id: this.model.id});
        this.feedback_autoreply = Cache.feedback_autoreply.findWhere({project_id: this.model.id});

        this.listenTo(Cache.feedback_autoreply, 'add', this.event_handlers.handleAddFeedbackAutoreply);
        this.listenTo(Cache.feedback_confirmation, 'add', this.event_handlers.handleAddFeedbackConfirmation);
    },

    isLoaded: function() {
        return this.feedback_confirmation ? true : false;
    },

    load: function() {
        if (!this.feedback_confirmation) {
            Cache.app.request({
                action: 'feedback\\Confirmation/get',
                data: {
                    project_id: this.model.id
                },
                success: (response) => {
                    Cache.feedback_confirmation.add(response);
                }
            });
        }

        if (!this.feedback_autoreply) {
            Cache.app.request({
                action: 'feedback\\Autoreply/search',
                data: {
                    project_id: this.model.id
                },
                success: (response) => {
                    Cache.feedback_autoreply.add(response);
                }
            });
        }
    },

    getAssigneeDropdown: function(assignee_type) {
        var setting_name  = 'default_assignee_id_' + assignee_type;
        var selected_user = Cache.user.get(this.model.get(setting_name));
        var all_users     = Cache.app.getUsersByProject(this.model.id, [Constants.ADMIN, Constants.ASSIGNEE]);

        var user_options = '<li data-id="0"' + (selected_user ? '' : ' class="selected"') + '><div class="user-24">?</div>Unassigned</li>';

        all_users.forEach((user) => {
            user_options +=
            '<li data-id="' + user.id + '"' + (user.id === this.model.get(setting_name) ? ' class="selected"' : '') + '>' +
                '<img class="user-24" src="' + user.getAvatar(24) + '">' + user.escape('name') +
            '</li>';
        });

        var html =
        '<div class="button-dropdown button-dropdown-large" data-append="true">' +
            '<button type="button" class="dropdown-select">' +
                (selected_user ?
                '<img class="icon-img icon-img-round" src="' + selected_user.getAvatar() + '">' + selected_user.escape('name') :
                'Unassigned') +
            '</button>' +
            '<div>' +
                (all_users.length > 10 ?
                '<div class="dropdown-search"><input type="text" class="solid compact" placeholder="Search user"></div>' : '') +
                '<ul class="dropdown dropdown-select dropdown-user" data-val="' + assignee_type + '">' + user_options + '</ul>' +
            '</div>' +
        '</div>';

        return html;
    },

    getDueDateDropdown: function(type) {
        var setting_name = 'default_due_day_' + type;
        var selected_value = this.model.get(setting_name);

        const due_days_list = [
            {name: 'No due date', value: 0},
            {name: '1 day', value: 1},
            {name: '2 days', value: 2},
            {name: '3 days', value: 3},
            {name: '4 days', value: 4},
            {name: '5 days', value: 5},
            {name: '6 days', value: 6},
            {name: '1 week', value: 7},
            {name: '2 weeks', value: 14},
            {name: '3 weeks', value: 21},
            {name: '4 weeks', value: 28}
        ];

        var days_options = '';

        due_days_list.forEach((due_day) => {
            days_options +=
            '<li data-id="' + due_day.value + '"' + (due_day.value === selected_value ? ' class="selected"' : '') + '>' +
                '<span>' + due_day.name + '</span>' +
            '</li>';
        });

        var selected_due_day = _.findWhere(due_days_list, {value: selected_value});
        var selected_label = selected_due_day ? selected_due_day.name : 'No Due Date';

        var html =
        '<div class="button-dropdown button-dropdown-large" data-append="true">' +
            '<button type="button" class="dropdown-select">' +
                (selected_value ? selected_label : '<span class="placeholder-text">No due date</span>') +
            '</button>' +
            '<div>' +
                '<ul class="dropdown dropdown-select dropdown-day" data-val="' + type + '">' + days_options + '</ul>' +
            '</div>' +
        '</div>';

        return html;
    },

    renderNewFeedbackAutomation: function(assignee_type) {
        switch (assignee_type) {
            case 'general':
                this.$el.find('.region-assignee-general').html(
                    '<div>If <b>General</b>,' +
                    ' assign it to ' + this.getAssigneeDropdown('general') +
                    ' and set due date to ' + this.getDueDateDropdown('general') + '</div>'
                );
                break;
            case 'bug':
                this.$el.find('.region-assignee-bug').html(
                    '<div>If <b>Bug</b>,' +
                    ' assign it to ' + this.getAssigneeDropdown('bug') +
                    ' and set due date to ' + this.getDueDateDropdown('bug') + '</div>'
                );
                break;
            case 'feature':
                this.$el.find('.region-assignee-feature').html(
                    '<div>If <b>Idea</b>,' +
                    ' assign it to ' + this.getAssigneeDropdown('feature') +
                    ' and set due date to ' + this.getDueDateDropdown('feature') + '</div>'
                );
                break;
        }

        if (!Cache.account.hasFeature('automation')) {
            this.$el.find('.dropdown-select').prop('disabled', true);
        }
    },

    render: function() {
        var content =
        '<div class="project-settings-inner-large form-fluid">' +
            (this.isLoaded() ?
            '<div class="field-label">New Feedback</div>' +
            '<div class="box-small-medium">' +
                '<p>When new feedback is received:</p>' +
                '<div class="region-assignee-general"></div>' +
                '<div class="divider-16"></div>' +
                '<div class="region-assignee-bug"></div>' +
                '<div class="divider-16"></div>' +
                '<div class="region-assignee-feature"></div>' +
            '</div>' +
            '<div class="divider-12"></div>' +

            '<div class="field-label">Reopen Feedback</div>' +
            '<div class="box-small-medium">' +
                '<div class="grid-9-3">' +
                    '<div><p>Automatically reopen feedback when reporter responds.</p></div>' +
                    '<div class="text-align-right"><button type="button" class="feedback-auto-reopen small ' + (this.model.get('feedback_auto_reopen') ? 'switch-on' : 'switch-off') + '"></button></div>' +
                '</div>' +
            '</div>' +
            '<div class="divider-12"></div>' +

            '<div class="field-label">Reporter Notification</div>' +
            '<div class="box-small-medium">' +
                '<div class="grid-9-3 margin-bottom-8">' +
                    '<div><p>Automatically send a confirmation email to the reporter when new feedback is received.</p></div>' +
                    '<div class="text-align-right"><button type="button" class="confirmation-is-disabled small ' + (this.feedback_confirmation.get('is_disabled') ? 'switch-off' : 'switch-on') + '"></button></div>' +
                '</div>' +
                '<div><a href="#" class="primary font-weight-medium edit-content" data-type="confirm"><i class="fa-solid fa-pen-to-square margin-right-4"></i>Edit Confirmation Email</a></div>' +
                '<div class="divider-16"></div>' +
                '<div class="grid-9-3 margin-bottom-8">' +
                    '<div><p>Enable a "Resolve & Auto-reply" option when marking feedback as resolved.</p></div>' +
                    '<div class="text-align-right"><button type="button" class="autoreply-is-disabled small ' + (!this.feedback_autoreply || this.feedback_autoreply.get('is_disabled') ? 'switch-off' : 'switch-on') + '"></button></div>' +
                '</div>' +
                '<div><a href="#" class="primary font-weight-medium edit-content" data-type="auto_reply"><i class="fa-solid fa-pen-to-square margin-right-4"></i>Edit Auto-reply</a></div>' +
            '</div>' +

            (Cache.account.hasFeature('automation') ? '' :


            '<div class="text-align-center margin-top-32">' +
                '<button type="button" class="account-upgrade shiny medium"><span>Upgrade my plan</span></button>' +
            '</div>')

            :

            // loading state
            '<div class="loader-placeholder margin-bottom-8"></div>' +
            '<div class="loader-placeholder margin-bottom-8"></div>' +
            '<div class="loader-placeholder"></div>') +
        '</div>';

        this.$el.html(content);

        if (!Cache.account.hasFeature('automation')) {
            this.$el.find('.feedback-auto-reopen').prop('disabled', true);
            this.$el.find('.confirmation-is-disabled').prop('disabled', true);
            this.$el.find('.autoreply-is-disabled').prop('disabled', true);
            this.$el.find('.dropdown-select').prop('disabled', true);
        }

        if (this.isLoaded()) {
            this.renderNewFeedbackAutomation('general');
            this.renderNewFeedbackAutomation('bug');
            this.renderNewFeedbackAutomation('feature');

        } else {
            this.load();
        }

        return this;
    }
});